module.exports = __webpack_public_path__ + "img/play-arrow-white.c94fa4b3.svg";